<template>
    <div>
        <div>
            <div class="d-flex justify-content-between">
                <div class="p-2"><h6>Escort Agencies</h6></div>
                <div class="p-2"><a @click="viewAll('escort-agencies')" class="btn btn-sm">View All</a></div>
            </div>
            <div class="d-flex"  style="overflow-x: auto; overflow-y: hidden ;">

                <div class="datum-grid col-lg-2 col-md-2 col-3 mb-1" v-for="agent in agencies">
                    <a @click="$router.push('/agent/' + agent.user_id + '/' + agent.id)">
                        <div class="card home-cards" @contextmenu="showPopUpImage(agent,'agency')">
                            <img slot="image" class="card-img-top" :src="agent.agency_details.profile_path"
                                alt="Card image cap" />
                            <div class="card-img-overlay text-white d-flex flex-column justify-content-center">
                                <span class="overlay_text"><span style="color: red; ">●</span> {{ agent.agency_name
                                }}</span>
                                <span class="overlay_text"> Model Count: {{ agent.count }}</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div><br>

        <div>
            <div class="d-flex justify-content-between">
                <div class="p-2"><h6>VIP Escorts</h6></div>
                <div class="p-2"><a @click="viewAll('vip-escorts')" class="btn btn-sm">View All</a></div>
            </div>
            <div class="d-flex"  style="overflow-x: auto; overflow-y: hidden ;">
                <br>


                <div class="datum-grid col-lg-2 col-md-2 col-3 mb-1" v-for="model in vipModels">
                    <a  @click="$router.push('/model/' + model.id)">
                        <div class="card home-cards" @contextmenu="showPopUpImage(model,'model')">
                            <img slot="image" class="card-img-top" :src="model.personal_details.profile_path"
                                alt="VIP model image" />
                            <div class="card-img-overlay text-white d-flex flex-column justify-content-center">
                                <span class="overlay_text" style="color: green;">● Online</span>
                                <span class="overlay_text" v-if="model.hasAllDetails"><span style="font-size: 15px;" >{{
                                    model.personal_details.nick_name }}</span> ,
                                    <!-- {{ model.location_details.city.charAt(0).toUpperCase() +
                                        model.location_details.city.slice(1) }} --></span>
                                <span class="overlay_text">Age : {{ " " + calculateAge(model.personal_details.date_of_birth)
                                }} years</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

        </div><br>

        <div>
            
            <div class="d-flex justify-content-between">
                <div class="p-2"><h6>NearBy Escorts</h6></div>
                <div class="p-2"><a @click="viewAll('nearby-escorts')" class="btn btn-sm">View All</a></div>
            </div>
            <div class="d-flex" style="overflow-x: auto; overflow-y: hidden ;">


                <div class="datum-grid col-lg-2 col-md-2 col-3 mb-1" v-for="model in nearbyModels">
                    <a @click="$router.push('/model/' + model.id)">
                        <div class="card home-cards">
                            <img slot="image" class="card-img-top" :src="model.personal_details.profile_path" @contextmenu="showPopUpImage(model,'model')"
                                alt="Nearby Model Image" />
                            <div class="card-img-overlay text-white d-flex flex-column justify-content-center">
                                <span class="overlay_text" v-if="model.hasAllDetails"><span style="color: green; "  >●</span>
                                     {{ model.personal_details.nick_name }} , <!--{{
                                        model.location_details.city.charAt(0).toUpperCase() +
                                        model.location_details.city.slice(1) }} -->
                                        </span>
                                <span class="overlay_text">Age : {{ " " + calculateAge(model.personal_details.date_of_birth)
                                }} years</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div><br>
        <div>
            
            <div class="d-flex justify-content-between">
                <div class="p-2"><h6>Premium Escorts In Your City</h6></div>
                <div class="p-2"><a @click="viewAll('premium-city')" class="btn btn-sm">View All</a></div>
            </div>
            <div class="d-flex" style="overflow-x: auto; overflow-y: hidden ;">


                <div class="datum-grid col-lg-2 col-md-2 col-3 mb-1" v-for=" model in premiumModels">
                    <a @click="$router.push('/model/' + model.id)" >
                        <div class="card home-cards">
                            <img slot="image" class="card-img-top" :src="model.personal_details.profile_path" @contextmenu="showPopUpImage(model,'model')"
                                alt="Premium Escorts Image" />
                            <div class="card-img-overlay text-white d-flex flex-column justify-content-center">
                                <span class="overlay_text" ><span style="color: green; " >●</span>
                                    {{ model.personal_details.nick_name }} , 
                                    <!-- {{
                                        model.location_details.city.charAt(0).toUpperCase() +
                                        model.location_details.city.slice(1) }} -->
                                        </span>
                                <span class="overlay_text">Age : {{ " " + calculateAge(model.personal_details.date_of_birth)
                                }} years </span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <div id="imageModal" class="modal custom-modal" style="display: none;" oncontextmenu="return false;">
            <span class="close">&times;</span>
            <img id="modalImage" src="" alt="Modal Image">
            <div id="caption"></div>
        </div>
    </div>
</template>
<script>
//import VideoPlayer from 'src/components/Video.vue';
import { api_url, datumMixin } from '../../env';
export default {
    name: 'home-page',
    layout: 'default',
    mixins: [datumMixin],


    data() {
        return {
            vipModels: [],
            nearbyModels: [],
            premiumModels: [],
            categories: [],
            agencies: [],
            age: null,
            userCity: null,
        };
    },
    methods: {

        getAgencies() {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),

            };
            this.$http.get(api_url + '/agents', { headers })
                .then(response => {
                    return response.json()
                }, response => {
                    return response
                })
                .then(response => {
                    if (response) {
                        if (response.status == 400) {
                            let bodyText = response.bodyText
                            bodyText = JSON.parse(bodyText)
                            this.alertNotification("top", "right", "danger", bodyText["message"])
                        } else if (response.status == "true") {

                            //steps
                            //1. Get all the data and prep it
                            response.agents.forEach(agent => {
                                let location_details = (agent.location_details) ? JSON.parse(agent.location_details) : null
                                let agency_details = (agent.agency_details) ? JSON.parse(agent.agency_details) : null
                                let payment_details = (agent.payment_details) ? JSON.parse(agent.payment_details) : null

                                //2 . Prep it
                                agent.location_details = location_details
                                agent.agency_details = agency_details
                                agent.payment_details = payment_details

                              

                            });


                            //3. Assign it to this.model
                            this.agencies = response.agents


                        }
                        else {
                            this.alertNotification("top", "right", "danger", response.statusText)
                        }
                    }
                    else {
                        this.alertNotification("top", "right", "danger", "We are unable to fetch info from the server. Try reloading the page")
                    }

                },
                )
        },

        getVipEscorts() {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),

            };
            this.$http.get(api_url + '/models?filter=vip', { headers })
                .then(response => {
                    return response.json()
                }, response => {
                    return response
                })
                .then(response => {
                    if (response) {
                        if (response.status == 400) {
                            let bodyText = response.bodyText
                            bodyText = JSON.parse(bodyText)
                            this.alertNotification("top", "right", "danger", bodyText["message"])
                        } else if (response.status == "true") {
                            //steps
                            //1. Get all the data and prep it
                            response.models.forEach(model => {
                               model = this.formatModelDetails(model)

                            });

                            //3. Assign it to this.model
                            this.vipModels = response.models
                            this.vipModels = this.vipModels.filter(model => model.hasAllDetails == true)


                        }
                        else {
                            this.alertNotification("top", "right", "danger", response.statusText)
                        }
                    }
                    else {
                        this.alertNotification("top", "right", "danger", "We are unable to fetch info from the server. Try reloading the page")
                    }

                },
                )
        },
        getNearbyModels() {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),

            };
            this.$http.get(api_url + '/models', { headers })
                .then(response => {
                    return response.json()
                }, response => {
                    return response
                })
                .then(response => {
                    if (response) {
                        if (response.status == 400) {
                            let bodyText = response.bodyText
                            bodyText = JSON.parse(bodyText)
                            this.alertNotification("top", "right", "danger", bodyText["message"])
                        } else if (response.status == "true") {
                            //steps
                            //1. Get all the data and prep it
                            response.models.forEach(model => {
                               model = this.formatModelDetails(model)

                            });

                            //3. Assign it to this.model
                            this.nearbyModels = response.models
                            this.nearbyModels = this.nearbyModels.filter(model => model.hasAllDetails == true)



                        }
                        else {
                            this.alertNotification("top", "right", "danger", response.statusText)
                        }
                    }
                    else {
                        this.alertNotification("top", "right", "danger", "We are unable to fetch info from the server. Try reloading the page")
                    }

                },
                )
        },
        getPremiumModels() {
            let headers = {
                "Authorization": "Bearer " + localStorage.getItem('token'),

            };
            if (!this.userCity) {
                console.error('User city not available.');
                return;
            }
            let clientLocation = JSON.stringify({ city: this.userCity });
            this.$http.get(api_url + '/models?filter=premium&client_location=' + clientLocation, { headers })
                .then(response => {
                    return response.json()
                }, response => {
                    return response
                })
                .then(response => {
                    if (response) {
                        if (response.status == 400) {
                            let bodyText = response.bodyText
                            bodyText = JSON.parse(bodyText)
                            this.alertNotification("top", "right", "danger", bodyText["message"])
                        } else if (response.status == "true") {
                            //steps
                            //1. Get all the data and prep it
                            response.models.forEach(model => {
                               model = this.formatModelDetails(model)

                            });

                            // Assign it to this.model
                            this.premiumModels = response.models
                            //only pick models with  allDetails
                            this.premiumModels = this.premiumModels.filter(model => model.hasAllDetails == true)



                        }
                        else {
                            this.alertNotification("top", "right", "danger", response.statusText)
                        }
                    }
                    else {
                        this.alertNotification("top", "right", "danger", "We are unable to fetch info from the server. Try reloading the page")
                    }

                },
                )
        },
        viewAll(type) {
            var criteria = ""
            var title = ""
            if (type == "escort-agencies") {
                criteria = '?take=50';
                title = "Escort Agencies"
                this.$router.push({ name: 'Agents', params: { criteria: criteria, title: title } })
                return;
            }
            else if (type == "vip-escorts") {
                criteria = '?filter=vip&take=50';
                title = "VIP Escorts"
            }
            else if (type == "nearby-escorts") {
                criteria = '?filter=near-by&take=50';
                title = "Near-By Escorts"
            }
            else if (type == "premium-city") {
                criteria = '?filter=premium&take=50';
                title = "Premium Escorts In Your City"
            }
            
            this.$router.push({ name: 'Models', params: { criteria: criteria, title: title } })
        },
        showPopUpImage(entity, type)
        {
            const mediaQuery = window.matchMedia('(max-width: 990px)');
            if (!mediaQuery.matches) {
                return  false;

            }

            let image=""
            let entityName=""
            let age=0
            let model_count=0
            let captionText = ""
            let location = ""
            if(type == "agency"){
                image = entity.agency_details.profile_path
                entityName = entity.agency_name
                model_count = entity.count
                
                captionText = "Model Count : " + model_count
                

            }
            else if(type == "model"){
                image = entity.personal_details.profile_path
                entityName = entity.personal_details.nick_name
                age = this.calculateAge(entity.personal_details.date_of_birth)
                location = entity.location_details.city.charAt(0).toUpperCase() +
                                        entity.location_details.city.slice(1) 
                captionText = "Name : "+entity.personal_details.nick_name+"<br> Age : " + age + " years" + " <br> Location :  " + location 
            }
            console.log(captionText)

            if (type == "model")
            {          
                 captionText += "<br> <a class='btn btn-primary' href='/#/model/"+entity.id+"'>View Profile</a>"
            }
            else if (type == "agency")
            {
                captionText += "<br> <a class='btn btn-primary' href='/#/agent/"+entity.user_id+"/"+entity.id+"'>View Profile</a>"
            }
            console.log(captionText)


         
            const modal = document.getElementById("imageModal");
            const modalImage = document.getElementById("modalImage");
            const caption = document.getElementById("caption");

            modal.style.display = "block";
            modalImage.src = image;
            caption.innerHTML = captionText;

            document.querySelector(".close").addEventListener("click", () => {
            modal.style.display = "none";
            });



        },
        reverseGeocode(latitude, longitude) {
            const geocodingApiUrl = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`;

            this.$http
                .get(geocodingApiUrl)
                .then((response) => response.json())
                .then((data) => {
                    if (data && data.address) {
                        // Try to get city, fallback to town/village/county/state
                        this.userCity =
                            data.address.city ||
                            data.address.town ||
                            data.address.village ||
                            data.address.county ||
                            data.address.state ||
                            "Nairobi";
                    } else {
                        this.userCity = "Nairobi";
                        this.alertNotification(
                            "top",
                            "right",
                            "danger",
                            "Unable to determine your city. Showing results for Nairobi."
                        );
                    }
                    // Now fetch premium models for this city
                    this.getPremiumModels();
                })
                .catch((error) => {
                    this.userCity = "Nairobi";
                    this.alertNotification(
                        "top",
                        "right",
                        "danger",
                        "Error determining your city. Showing results for Nairobi."
                    );
                    this.getPremiumModels();
                });
        },
        getUserLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.userLatitude = position.coords.latitude;
                        this.userLongitude = position.coords.longitude;
                        this.reverseGeocode(this.userLatitude, this.userLongitude);
                        this.getNearbyModels();
                    },
                    (error) => {
                        this.userLatitude = -1.286389;
                        this.userLongitude = 36.817223;
                        this.userCity = "Nairobi";
                        this.alertNotification(
                            "top",
                            "right",
                            "danger",
                            "Unable to get your location. Showing results for Nairobi."
                        );
                        // Still fetch models for default location
                        this.getNearbyModels();
                        this.getPremiumModels();
                    },
                    {
                        enableHighAccuracy: true,
                        timeout: 10000,
                        maximumAge: 0
                    }
                );
            } else {
                // Geolocation not supported
                this.userLatitude = -1.286389;
                this.userLongitude = 36.817223;
                this.userCity = "Nairobi";
                this.alertNotification(
                    "top",
                    "right",
                    "danger",
                    "Geolocation is not supported by this browser. Showing results for Nairobi."
                );
                this.getNearbyModels();
                this.getPremiumModels();
            }
        },


    },
    created() {
        this.getVipEscorts();
        this.getAgencies();
        this.getNearbyModels();
        this.getPremiumModels();
        //this.calculateAge(birthDate);
        this.getUserLocation();

    }

};
</script>
<style >
.datum-grid {
    padding-right: 1px;
    padding-left: 1px;
    padding-top: 1px;
    padding-bottom: 10px;
    justify-content: center;
    padding: auto;
}

/* .card-img-overlay {
    top: 70%;
    background-color: rgba(0, 0, 0, 0.5)
} */
.card-img-overlay {
    /* display: none; */
    top: 0%;
}

.overlay_text {
    display: none;
}



.datum-grid img {
    aspect-ratio: 2/3;
    object-fit:cover;
    mix-blend-mode:exclusion;
}

/* .modalImage{
    aspect-ratio: 1;
    object-fit: contain;
    mix-blend-mode: normal;
} */

.custom-modal {
    display: none;
    position: fixed;
    z-index: 1;
    padding-top: 50%;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.9);
}

.custom-modal img {
    display: block;
    margin: 0 auto; /* Center the image horizontally */
    max-width: 80%; /* Adjust the size as needed */
    max-height: 80vh; /* Adjust the size as needed */
}

.close {
    position: absolute;
    top: 50px;
    right: 10px;
    font-size: 30px;
    cursor: pointer;
    color: white;
}

#caption {
    text-align: center;
    color: white;
    padding: 10px;
    max-width: 90%;
    margin: 0 auto; /* Center the caption horizontally */
}

.home-cards{
    background-color: #1e1e2d;
}


@media screen and (min-width: 1201px) {
    .datum-grid {
        /* height: 24.5rem; */
    }

    
    .home-cards:hover .card-img-overlay {
        top: 70%;
        background-color: rgba(0, 0, 0, 0.5);
        /* transition: all 0.3s; Add a transition for smooth effect */
    }
 

    .home-cards:hover .overlay_text {
        display: block;
    }


}

@media screen and (min-width: 991px) and (max-width: 1200px) {
    .datum-grid {
        /* height: 17.5rem; */
    }



}

@media screen and (min-width: 700px) and (max-width: 990px) {
    .datum-grid {
        /* height: 14rem; */
    }


}

@media screen and (max-width: 700px) {
    .datum-grid {
        /* height: 7.5rem; */
    }



    .overlay_text {
        font-size: 7px;
        font-weight: bold;
    }
}
</style>
  